<script setup>
import Card from "@/components/ui/card/Card.vue";
import InputGroup from "@/components/ui/input-group/InputGroup.vue";
import InputGroupAddon from "@/components/ui/input-group/InputGroupAddon.vue";
import InputGroupInput from "@/components/ui/input-group/InputGroupInput.vue";
import Label from "@/components/ui/label/Label.vue";
import { Search } from "lucide-vue-next";
import { computed, ref } from "vue";
import GameCard from "@/components/GameCard.vue";

const emit = defineEmits(["toggleInterest", "changeSortMode", "changeSearch"]);

const props = defineProps({
  interests: {
    type: Array,
    default: () => [],
  },
  uid: {
    type: String,
    required: true,
  },
  ownedGames: {
    type: Array,
    default: [],
  },
  sortMode: {
    type: String,
    default: "",
  },
  isMobile: {
    type: Boolean,
  },
  search: {
    type: String,
    default: "",
  },
  profiles: {
    type: Array,
    default: []
  }
});

function isInterestedInGame(game, uid) {
  const foundGame = findGame(game);
  if (foundGame === null) return false;
  return foundGame.users && foundGame.users.includes(uid);
}

function interestedProfiles(game, userIds){
  const interestedList = []
  if(userIds){
    userIds.forEach(userId => {
      if (isInterestedInGame(game, userId)){
        const matches = props.profiles.filter(a => a.id == userId)
        interestedList.push(...matches)
      }
    });
  }
  return interestedList
}

const formattedGames = computed(() => {
  return props.ownedGames.map((data) => data.game);
});

function steamIconUrl(game) {
  return `https://media.steampowered.com/steamcommunity/public/images/apps/${game.id}/${game.icon}.jpg`;
}

function findGame(game) {
  // find game in interests
  const foundGame =
    props.interests.find((interest) => interest.id == game.id) || null;
  return foundGame;
}

function changeSort(value) {
  if (props.sortMode == value) {
    emit("changeSortMode", null);
  } else {
    emit("changeSortMode", value);
  }
}

function setSearch(value) {
  emit("changeSearch", value);
}
</script>

<template>
  <Card
    class="border-0 rounded-0 shadow-none p-4 w-full h-full min-h-svh bg-background pb-50"
  >
    <div class="flex flex-row items-center gap-4">
      <InputGroup class="grow">
        <InputGroupInput
          placeholder="Search Games..."
          @update:model-value="setSearch"
          :model-value="props.search"
        />
        <InputGroupAddon>
          <Search />
        </InputGroupAddon>
      </InputGroup>
    </div>

    <div class="flex flex-row w-full">
      <div class="m-0 w-full mr-2">
        <Label
          class="hover:bg-accent/50 hover:cursor-pointer flex items-start gap-3 rounded-lg border p-3 has-aria-checked=true:border-primary has-aria-checked=true:bg-primary/50 dark:has-aria-checked=true:border-primary/50 dark:has-[[aria-checked=true]]:bg-primary/20"
          :class="
            props.sortMode === 'playtime'
              ? 'border-green-500 bg-green-50 dark:bg-green-950/20'
              : ''
          "
          @click="changeSort('playtime')"
        >
          <div class="grid gap-1.5 font-normal">
            <p class="text-sm leading-none font-medium">Sort by Playtime</p>
          </div>
        </Label>
      </div>

      <!-- <div class="m-0 w-full mr-2"> Not supported!!
                <Label
                    class="hover:bg-accent/50 hover:cursor-pointer flex items-start gap-3 rounded-lg border p-3 has-aria-checked=true:border-primary has-aria-checked=true:bg-primary/50 dark:has-aria-checked=true:border-primary/50 dark:has-[[aria-checked=true]]:bg-primary/20"
                    :class="props.sortMode === 'lastPlayed' ? 'border-green-500 bg-green-50 dark:bg-green-950/20' : ''"
                    @click="changeSort('lastPlayed')">
                    <div class="grid gap-1.5 font-normal">
                        <p class="text-sm leading-none font-medium">Sort by Last Played</p>
                    </div>
                </Label>
            </div> -->
    </div>

    <h2 v-if="!props.isMobile">Add Your Games</h2>

    <div
      v-for="game in formattedGames"
      :key="game.name"
      class="flex flex-row items-center"
    >
      <GameCard
        :name="game.name"
        :imageURL="steamIconUrl(game)"
        :isInterested="isInterestedInGame(game, props.uid)"
        :countInterested="findGame(game)?.users?.length || 0"
        :interestedProfiles="interestedProfiles(game, findGame(game)?.users)"
        @toggleInterest="$emit('toggleInterest', game)"
      >
      </GameCard>
    </div>
  </Card>
</template>
